/*eslint-disable */
import React, { useState } from "react";

interface DatosComponentProps {
  modelo: any;
  modelos: any;
  version: any;
  setCurrentIndex: any;
  cuotaInicial: any;
  setCuotaInicial: any;
  plazo: any;
  setPlazo: any;
  frecuenciaPago: any;
  setFrecuenciaPago: any;
  diaPago: any;
  setDiaPago: any;
  tipoPlan: any;
  setTipoPlan: any;
  cuotaExtra: any;
  setCuotaExtra: any;
  setSend: any
  vehiculos: any
}

const DatosComponent: React.FC<DatosComponentProps> = ({
  modelo,
  modelos,
  version,
  setCurrentIndex,
  cuotaInicial,
  setCuotaInicial,
  plazo,
  setPlazo,
  frecuenciaPago,
  setFrecuenciaPago,
  diaPago,
  setDiaPago,
  tipoPlan,
  setTipoPlan,
  cuotaExtra,
  setCuotaExtra,
  setSend,
  vehiculos
}) => {
  const [inputValue, setInputValue]: any = useState(cuotaInicial);
  const [inputValueExtra, setInputValueExtra]: any = useState("0");

  const formatCurrency = (value: number) => {
    return new Intl.NumberFormat("es-CO", {
      style: "currency",
      currency: "COP",
      minimumFractionDigits: 0,
    }).format(value);
  };

  const handleCuotaInicialChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    // Eliminar caracteres no numéricos antes de formatear
    const rawValue = e.target.value.replace(/[^\d]/g, ""); // Mantener solo los números
    const numberValue = Number(rawValue);

    setInputValue(rawValue ? formatCurrency(numberValue) : "0");
    setCuotaInicial(numberValue);
  };


  const cuotaInicialChange = (e: any) => {
    // Eliminar caracteres no numéricos antes de formatear
    const rawValue = e.replace(/[^\d]/g, ""); // Mantener solo los números
    const numberValue = Number(rawValue);

    return rawValue ? formatCurrency(numberValue) : "0"
  }

  const handleCuotaExtraChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    // Eliminar caracteres no numéricos antes de formatear
    const rawValue = e.target.value.replace(/[^\d]/g, ""); // Mantener solo los números
    const numberValue = Number(rawValue);

    setInputValueExtra(rawValue ? formatCurrency(numberValue) : "0");
    setCuotaExtra(numberValue);
  };

  return (
    <div className="content-simulador-component alturaLimitada">
      <h1>Simulador de cuotas</h1>
      <div className="step-content-simulador-component">
        <div className="step_1 active" onClick={() => setCurrentIndex(0)}>
          <span>1</span>
        </div>
        <div className="line active"></div>
        <div className="step_2 active" onClick={() => setCurrentIndex(1)}>
          <span>2</span>
        </div>
      </div>
      <div className="subtitle-2-content-simulador-component">
        Llena los campos.
      </div>
      <div className="vehiculo-content-simulador-component">
        {vehiculos?.find((item: any) => item.slug === modelo)?.name + " " + version}
      </div>
      <div className="precio-content-simulador-component">
        {formatCurrency(vehiculos?.find((item: any) => item.slug === modelo)?.versions?.find((e: any) => e.name === version)?.price)} *
      </div>
      <div className="internal-2-content-simulador-component">
        <div className="input-internal-2-content-simulador-component">
          <label htmlFor="datos-cuota-inicial">Cuota inicial</label>
          <input
            type="text"
            id="datos-cuota-inicial"
            value={cuotaInicialChange(cuotaInicial)}
            //onChange={handleCuotaInicialChange}
            onChange={(e: any) => setCuotaInicial(e.target.value.replace(/[^\d]/g, ""))}
          />
        </div>
        <div className="input-internal-2-content-simulador-component">
          <label htmlFor="datos-plazo">Plazo</label>
          <select
            name=""
            id="datos-plazo"
            value={plazo}
            onChange={(e) => setPlazo(e.target.value)}
          >
            <option value={24}>24</option>
            <option value={36}>36</option>
            <option value={48}>48</option>
            <option value={60}>60</option>
            <option value={72}>72</option>
          </select>
        </div>
        <div className="input-internal-2-content-simulador-component">
          <label htmlFor="datos-dia-pago">Día de pago</label>
          <select name="" id="datos-dia-pago"
            value={diaPago}
            onChange={(e) => setDiaPago(e.target.value)}>
            <option value={2}>2</option>
            <option value={10}>10</option>
            <option value={17}>17</option>
            <option value={25}>25</option>
          </select>
        </div>
      </div>
      <div
        className={`btn-2-next-content-simulador-component ${
          modelo !== "" ? "active" : ""
        }`}
        onClick={() => setSend(true)}
      >
        Simula mi cuota
      </div>
    </div>
  );
};

export default DatosComponent;
